export function getSanitizedProviderName(name: string): string {
    if (!name) {
        return "";
    }
    return name.replaceAll("*", "").replaceAll("/", " ").trim();
}
